import React from "react";
import { AttributeController } from "./AttributeController";
import { AttributeViewModel } from "./AttributeViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class AttributeProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new AttributeViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <AttributeController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/AttributeProvider.js